import { attrConfig as rsidRConfig } from './w-rsid-r.js';
import { attrConfig as rsidRPrConfig } from './w-rsid-r-pr.js';
import { attrConfig as rsidDelConfig } from './w-rsid-del.js';

/** @type {import('@translator').AttrConfig[]} */
export default [rsidRConfig, rsidRPrConfig, rsidDelConfig];
